import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './Helpcenter.css';
import Header from './Header';
import Footer from './Footer';

const HelpCenterContact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const requestData = {
            Name: formData.name,
            Email: formData.email,
            Message: formData.message
        };

        try {
            const response = await fetch('https://api.ndtechland.com/api/HomeApi/AddHelpCenter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });

            const data = await response.json();

            if (data.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: data.message,
                    icon: 'success',
                    confirmButtonText: 'Close'
                });

                setFormData({
                    name: '',
                    email: '',
                    message: ''
                });
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: data.message || 'Something went wrong. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'Close'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Error: ' + error.message,
                icon: 'error',
                confirmButtonText: 'Close'
            });
        }
    };

    return (
        <section className="nd-help-contact-card">
            <h2>Contact Support</h2>
            <form className="nd-contact-form" onSubmit={handleSubmit}>
                <div className="nd-form-group">
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Your full name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="nd-form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="your.email@example.com"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        style={{ textAlign: "left" }}
                    />
                </div>
                <div className="nd-form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                        id="message"
                        name="message"
                        rows="4"
                        placeholder="Describe how we can help you..."
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        style={{ textAlign: "left" }}
                    ></textarea>
                </div>
                <button type="submit" className="nd-help-submit-btn">Submit</button>
            </form>
        </section>
    );
};

const Helpcenter = () => {
    return (
        <div>
            <Header />

            <div className="nd-helpcenter-page">
                <div className="nd-helpcenter-container container">
                    {/* Hero Header */}
                    <div className="nd-helpcenter-hero">
                        <div className="nd-helpcenter-badge">Support & Assistance</div>
                        <h1 className="nd-helpcenter-title">Help Center</h1>
                        <p className="nd-helpcenter-subtitle">We're here to help you with any questions or concerns.</p>
                    </div>

                    {/* Quick Support Channels */}
                    <div className="nd-help-channels-grid">
                        <div className="nd-help-channel-card">
                            <div className="nd-channel-icon">📧</div>
                            <div className="nd-channel-info">
                                <h6>Email Support</h6>
                                <p>info@ndtechland.com</p>
                            </div>
                        </div>
                        <div className="nd-help-channel-card">
                            <div className="nd-channel-icon">📞</div>
                            <div className="nd-channel-info">
                                <h6>Phone Assistance</h6>
                                <p>+91 8826302378</p>
                            </div>
                        </div>
                        <div className="nd-help-channel-card">
                            <div className="nd-channel-icon">⚡</div>
                            <div className="nd-channel-info">
                                <h6>Fast Resolution</h6>
                                <p>Mon - Sat (9:30 AM - 6:30 PM)</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Split Grid: FAQ + Contact Support */}
                    <div className="nd-helpcenter-main-grid">
                        {/* FAQ Card */}
                        <section className="nd-help-faq-card">
                            <h2>Frequently Asked Questions</h2>
                            <div className="nd-faq-items-wrap">
                                <div className="nd-faq-item-box">
                                    <h3>How do I reset my password?</h3>
                                    <p>You can reset your password by clicking the "Forgot Password" link on the login page.</p>
                                </div>
                                <div className="nd-faq-item-box">
                                    <h3>How do I contact support?</h3>
                                    <p>You can contact support by emailing support@example.com or using the contact form below.</p>
                                </div>
                                <div className="nd-faq-item-box">
                                    <h3>Where can I find the user manual?</h3>
                                    <p>The user manual is available in the Resources section of your account dashboard.</p>
                                </div>
                            </div>
                        </section>

                        {/* Contact Form Card */}
                        <HelpCenterContact />
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Helpcenter;
